import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239f659d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-bold fs-5 mb-3 mb-lg-4 text-center" }
const _hoisted_2 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "mb-lg-5 mb-3 position-relative" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex justify-content-center mb-2" }
const _hoisted_6 = { class: "fw-bold text-center fs-6" }
const _hoisted_7 = { class: "text-center mb-0 fs-7" }

import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { translate } from '@/languages/i18n'
import { addUserIconParams } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  props: {
  imageUrl: String,
  userType: String,
  name: String,
  displayName: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(translate)('profile')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: __props.imageUrl ? _unref(addUserIconParams)(__props.imageUrl, __props.userType) : require('@/assets/images/user-empty.svg'),
          alt: "user",
          class: "mb-2 icon_avatar cursor-pointer m-auto d-flex rounded-circle"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(UserAliasIcon, { userType: __props.userType }, null, 8, ["userType"])
        ]),
        _createElementVNode("h3", _hoisted_6, _toDisplayString(__props.name), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(__props.displayName), 1)
      ])
    ])
  ], 64))
}
}

})